import React from 'react';

import { WarningMessage } from 'features/nekst-widgets';
import useSettingsNavigator from '../settingsNavigator';
import { TextLink } from 'ui-builder';
import { useTeamSetupAreasContextRequired } from './TeamSetupAreasContext';
import { useAuthenticationContext } from 'nekst-api';


function NoMarketsInformationMessageContent() {
  const teamSetupAreasContext = useTeamSetupAreasContextRequired();

  const teamSetupAreas = teamSetupAreasContext.teamSetupAreas;

  const settingsNavigator = useSettingsNavigator();

  const authenticationContext = useAuthenticationContext();

  if (teamSetupAreas && teamSetupAreas.length === 0 && authenticationContext?.user.hasActiveAccount) {
    return (
      <WarningMessage>
        You don't have any markets or processes set up yet.
        {' '}
        To get started,
        {' '}
        <TextLink
          onClick={() => {
            settingsNavigator.openMarketsPage();
          }}
        >
          add a market from the available options or create a custom process
        </TextLink>.
      </WarningMessage>
    );
  } else {
    return null;
  }
}


export default function NoMarketsInformationMessage() {
  const authenticationContext = useAuthenticationContext();

  if (authenticationContext?.user) {
    return <NoMarketsInformationMessageContent />;
  } else {
    return null;
  }
}
